import { css } from 'styled-system/css';

export const articleContainerStyle =  {
	content: css({
		flex: 1,
		fontSize: '14px',
		color: 'black.2',
		p: '12px',
		overflow: 'auto',
	}),
	title: css({
		color: 'secondary.500',
		fontWeight: '700',
		fontSize: '16px',
	}),
}